import { z } from 'zod';
// Confirmed response shape for POST /api/v1/auth/login-connect (verified 2026-04-07).
// {
//   success: true,
//   errorCode: '000000',
//   message: '',
//   data: {
//     accessToken: string,
//     refreshToken: string,
//     user: {
//       _id: string,          ← mapped to uid in AuthUser
//       fullname: string,     ← mapped to displayName in AuthUser
//       email: string,
//       avatar: string,
//       username: string,
//       role: 'ADMIN' | ...,
//       membership: 'FREE' | ...,
//       isOnboarding: boolean,
//       isConnectedDevice: boolean,
//       gender: string,
//       anonId: string,
//       location: { address, country, lat, long },
//       height: number | null,
//       weight: number | null,
//       startVip: string | null,
//       endVip: string | null,
//     }
//   },
//   meta: {}
// }
export const LoginResponseSchema = z.object({
    success: z.boolean(),
    errorCode: z.string(),
    message: z.string(),
    data: z.object({
        accessToken: z.string(),
        refreshToken: z.string(),
        user: z.object({
            _id: z.string(),
            fullname: z.string(),
            email: z.string().nullable(),
            avatar: z.string(),
            username: z.string(),
            role: z.string(),
            membership: z.string(),
            isOnboarding: z.boolean(),
            isConnectedDevice: z.boolean(),
            gender: z.string(),
            anonId: z.string(),
            height: z.number().nullable(),
            weight: z.number().nullable(),
            startVip: z.string().nullable(),
            endVip: z.string().nullable(),
        }),
    }),
    meta: z.record(z.string(), z.unknown()),
});
// Normalized user identity stored in the auth store.
// Raw API fields _id and fullname are remapped to uid and displayName in useLogin().
export const AuthUserSchema = z.object({
    uid: z.string(),
    email: z.string().nullable(),
    displayName: z.string(),
    avatar: z.string(),
    username: z.string(),
    role: z.string(),
    membership: z.string(),
});
